<!--
 * @Description: 未归宿学生
 * @Author: PF
 * @Date: 2023-02-03 15:00:22
 * @LastEditors: PF
 * @LastEditTime: 2024-08-22 14:58:28
-->
<template>
  <div>
    <el-dialog class="wp90 hp90" :model-value="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <span class="header-title">未归宿学生 （{{ tableData.length }}人）</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openList', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pt0 pl0 pb0 pr0">
        <el-table :data="tableData" height="100%" border stripe>
          <!-- 冻结列-Left BEGIN -->
          <el-table-column label="序号" type="index" width="55" fixed align="center" />
          <!-- 冻结列-Left END -->
          <el-table-column label="日期" prop="rq" width="100" align="center" show-overflow-tooltip />
          <el-table-column label="考勤时间点" prop="kqsjd" align="center" show-overflow-tooltip />
          <el-table-column label="学号" prop="xh" align="center" show-overflow-tooltip />
          <el-table-column label="学生" prop="xm" align="center" show-overflow-tooltip />
          <el-table-column label="性别" prop="xb" width="55" align="center" show-overflow-tooltip/>
          <el-table-column label="校区" prop="xqmc" align="center" show-overflow-tooltip />
          <el-table-column label="专业" prop="zymc" align="center" show-overflow-tooltip />
          <el-table-column label="年级" prop="njmc" align="center" show-overflow-tooltip />
          <el-table-column label="班级" prop="bjmc" align="center" show-overflow-tooltip />
          <el-table-column label="联系电话" prop="lxdh" align="center" show-overflow-tooltip />
          <el-table-column label="宿舍楼" prop="jzwmc" align="center" show-overflow-tooltip />
          <el-table-column label="楼层" prop="fjlc" width="55" align="center" show-overflow-tooltip :formatter="fjlcFormat" />
          <el-table-column label="宿舍" prop="fjbh" align="center" show-overflow-tooltip />
          <el-table-column label="状态" prop="zszt" width="70" align="center" show-overflow-tooltip :formatter="zsztFormat"/>
        </el-table>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openList', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, defineProps, watch, defineEmits } from 'vue'
import { loadSelect, closeWindow } from '@/api/common.js'
import { getDate } from '@/utils/index.js'
import { getSsKqGszt, getSsKqSjdLx } from '@/utils/meiju.js'

const props = defineProps({
  openList: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openList', 'ReturnData'])

const parms = ref({})
const tableData = ref([])

const bindTable = () => {
  loadSelect({ url: '/api/v2/sushe/sushekaoqin/weiguisuxueshenglist', data: tableData, order: 'rq', sort: 'desc', parms: parms.value })
}
// 获取状态名称
const fjlcFormat = (row) => {
  const info = row.fjlc < 1 || row.fjlc === null ? '无' : row.fjlc
  return info
}
// 获取状态名称
const zsztFormat = (row) => {
  const info = getSsKqGszt().list.find(item => item.value === row.zszt)
  return info ? info.label : ''
}

watch(
  () => props.openList,
  () => {
    if (props.openList) {
      parms.value.tsid = props.row.id
      bindTable()
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
</style>
